import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB56VRUShAfXiyRLNBBJnGImzTxw6-gxuo",
  authDomain: "image-uploader-22f5c.firebaseapp.com",
  projectId: "image-uploader-22f5c",
  storageBucket: "image-uploader-22f5c.appspot.com",
  messagingSenderId: "704898373198",
  appId: "1:704898373198:web:c637eaeb399cd98395151f",
};

export const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
